export const CARDIOLOGY = 'cardiology';
export const INTERNIST = 'internist';
export const ANESTHESIOLOGIST = 'anesthesiologist';
